import React from 'react'
import { Helmet } from 'react-helmet-async'


function About() {
  return (
    <>
      <Helmet>
          <title>About-NagsPro</title>
          <meta name="description" content="North Atlantic Global Services (NAGS) is a multi-competency technology consulting firm with expertise and capability across many industries and business functions to help clients optimize their performance and profitability."/>
          <link rel="canonical" href="/About"/>
        </Helmet>

    <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            About Us
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              {/* <li className="breadcrumb-item">
                <a href="/Pages">Pages</a>
              </li> */}
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                About
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
        
            {/* About Start */}
            <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/abt.jpg"
                alt="about_us"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            <h6 className="section-title bg-white text-start text-primary pe-3">
              About Us
            </h6>
            <h1 className="mb-4">
              Welcome to <span className="text-primary">NagsPro</span>
            </h1>
            <p className="mb-4">
            North Atlantic Global Services (NAGS) is a multi-competency technology consulting firm with expertise and capability 
            across many industries and business functions to help clients optimize their performance and profitability.
            </p>
            <p className="mb-4">
            We have built a strong and diverse team with collective industry experience in different sectors such as :
            </p>
            <div className="row gy-2 gx-4 mb-4">
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Healthcare
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Retail & eCommerce
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Travel & Tourism
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Logistics & Transportation
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Banking & Finance
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Government Administration
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Textile & Garments
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                 Church Applications
                </p>
              </div>
            </div>
            <p className="mb-4">
            Our strong technical competence in deploying and supporting innovative technology has 
            helped our customers get best fit, quality solutions that meet their business demands. 
            Because we understand the challenges that our customers face, we do things differently at NAGS. 
            Unlike traditional consultants, who benefit from engagements that lead to more engagements and 
            are not oriented toward a specific, predictable and measurable outcome, we work with customers 
            to identify high-impact, short-duration projects that deliver returns quickly. Our consultants 
            focus on standards to ensure objectivity when recommending solutions.
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* About End */}

    </div>
    </>
  )
}

export default About